import { createSvgIcon } from '@material-ui/core';

export const ShortText = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 12 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.666016 0H11.3327V1.33333H0.666016V0ZM0.666016 2.66667H7.33268V4H0.666016V2.66667Z" fill="#6B7280" />
  </svg>,
  'ShortText',
);
